<div
  [class.terms-disabled]="removalStatus === 'removing'"
  class="d-flex justify-content-start"
>
  @if (pdpTerms.isPdpTerms) {
    <a
      (click)="openTermsAndConditionsModal()"
      (keydown.enter)="openTermsAndConditionsModal()"
      class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
      data-cy="resource-terms-and-conditions"
      target="_blank"
    >
      <img
        *ngIf="pdpTerms.showIconLink"
        alt="legal paper"
        class="udex-me-16"
        src="../../../assets/images/newspaper_blue.svg"
      />
      {{'productDetails.termsAndConditions' | cxTranslate}}
    </a>
  } @else {
    <udex-link
      (click)="openTermsAndConditionsModal()"
      (keydown.enter)="openTermsAndConditionsModal()"
      data-cy="resource-terms-and-conditions"
      class="body--xs"
    >
      <img
        *ngIf="pdpTerms.showIconLink"
        alt="legal paper"
        class="udex-me-16"
        src="../../../assets/images/newspaper_blue.svg"
      />
      <span [class]="'body--' + udexLinkBodySize">{{'productDetails.termsAndConditions' | cxTranslate}}</span>
    </udex-link>
  }
</div>

<ng-template #modalContentTemplate>
  <div
    [ngClass]="isNetNewTermsConditions ? [] : ['terms-conditions-modal__container--dynamic']"
  >
    <udex-select-box
      *ngIf="entryToShow?.product" class="terms-conditions-modal__select-box body--s" mode="SingleSelect"
      (selection-change)="valueChange(($event)?.detail.selectedItems[0].dataset.value)"
      [label]="'productDetails.solution' | cxTranslate"
    >
      <udex-select-box-item
        *ngFor="let item of entriesToShow"
        [attr.data-value]="item?.product?.name"
        [attr.label]="item?.product?.name + ' (' + item?.product?.supplierAlternativeAID + ')'"
        [selected]="item===entriesToShow[0]"
      >
      </udex-select-box-item>
    </udex-select-box>

    <div
      *ngIf="!isNetNewTermsConditions; else netNewTermsConditions"
      class="terms-conditions-modal__dynamic-content udex-mt-16 udex-mt-sm-20 body--xxs"
    >
      <div
        *ngIf="termsAndConditionsDynamicContent?.poNumber"
        class="terms-conditions-modal__dynamic-content__description"
      >
        <span>{{termsAndConditionsDynamicContent.addOrderForm}}</span>
      </div>
      <div class="terms-conditions-modal__dynamic-content__text body--s udex-mt-24 udex-mt-sm-32">
        <table class="content-table">
          <tr *ngIf="termsAndConditions?.contractId && termsAndConditionsDynamicContent?.contractId">
            <td class="udex-mb-8 udex-mb-sm-12">{{termsAndConditionsDynamicContent.contractId}}</td>
            <td class="udex-mb-16 udex-mb-sm-20">
              {{termsAndConditions.contractId}}
            </td>
          </tr>
          <tr *ngIf="termsAndConditions?.startDate && termsAndConditionsDynamicContent?.startDate">
            <td class="udex-mb-8 udex-mb-sm-12">{{termsAndConditionsDynamicContent.startDate}}</td>
            <td class="udex-mb-16 udex-mb-sm-20">{{termsAndConditions.startDate | date: 'dd MMM yyyy'}}</td>
          </tr>
          <tr *ngIf="termsAndConditions?.caseId && termsAndConditionsDynamicContent?.caseId">
            <td class="udex-mb-8 udex-mb-sm-12">{{termsAndConditionsDynamicContent.caseId}}</td>
            <td class="udex-mb-16 udex-mb-sm-20">{{termsAndConditions.caseId}}</td>
          </tr>
          <tr *ngIf="termsAndConditions?.quoteId && termsAndConditionsDynamicContent?.quoteId">
            <td class="udex-mb-8 udex-mb-sm-12">{{termsAndConditionsDynamicContent.quoteId}}</td>
            <td class="udex-mb-16 udex-mb-sm-20">{{termsAndConditions.quoteId}}</td>
          </tr>
          <tr *ngIf="termsAndConditions?.poNumber && termsAndConditionsDynamicContent?.poNumber">
            <td class="udex-mb-8 udex-mb-sm-12">{{termsAndConditionsDynamicContent.poNumber}}</td>
            <td class="udex-mb-16 udex-mb-sm-20">{{termsAndConditions.poNumber}}</td>
          </tr>
        </table>
      </div>
    </div>
    <ng-template #netNewTermsConditions>
      <div
        id="termsToPrint"
        #termsToPrint
        class="terms-conditions-modal__content udex-mt-16 udex-mt-sm-20 body--xxs"
      >
        <div
          class="injected-content"
          [innerHTML]="termsAndConditionsNetNewEntryHtml"
          (click)="triggerEddlDownloadAttemptEvent($event); triggerEddlDownloadSuccessEvent($event)"
        ></div>
      </div>
    </ng-template>
  </div>
</ng-template>
<ng-template #modalFooterTemplate>
  <div
    *ngIf="isNetNewTermsConditions"
    class="terms-conditions-modal__footer"
    slot="footer"
    design="Footer"
    data-sap-ui-fastnavgroup="true"
  >
    <udex-button class="terms-conditions-modal__footer__button" (click)="onPrint()" design="Primary" size="Large">
      {{'productDetails.termsConditions.printTermsButton' | cxTranslate}}
    </udex-button>
    <udex-button
      class="terms-conditions-modal__footer__button udex-ms-20"
      (click)="closeTermsAndConditionsModal()"
      design="Secondary"
      size="Large"
    >{{'productDetails.termsConditions.closePrintTermsButton' | cxTranslate}}
    </udex-button>
  </div>
</ng-template>
